export { WindowSkeleton } from "./WindowSkeleton"
